module.exports = __webpack_public_path__ + "img/yb4.6930c2d8.jpg";